export default {"src":"/_next/static/media/carOutline_40.0d2ded6b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};